import moment from "moment";
import { NEWS_PARAMS } from "apis/constants";
import { fetchNext } from "../utils/request";
import requestTypes from "../constants/requestTypes";
import type { GetNewsResponse } from "./models/news";
import type { GetNewsByIdResponse } from "./models/newsDetails";
import type { GetNewsFileByIdResponse } from "./models/newsFile";
import type { GetNewsServices } from "./models/newsServices";
import { getApiNewsUrl } from "../utils/endpoints";

const newsUrl = getApiNewsUrl();

export default class NewsApi {
  static getAllNews = (
    rows: number,
    sectors: string,
    startDate?: Date,
    endDate?: Date,
    page: number
  ): Promise<GetNewsResponse> => {
    const url = `/news?${NEWS_PARAMS}&rows=${rows}&page=${page}${
      sectors !== "" ? `&sectors=${sectors}` : ""
    }${
      startDate ? `&startDate=${moment(startDate).format("YYYY-MM-DD")}` : ""
    }${endDate ? `&endDate=${moment(endDate).format("YYYY-MM-DD")}` : ""}`;
    return fetchNext(requestTypes.GET, url, undefined, newsUrl);
  };

  static getServices = (): Promise<{ data: GetNewsServices }> =>
    fetchNext(requestTypes.GET, `/news/services`, undefined, newsUrl);

  static getNewsDetails = (id: number): Promise<GetNewsByIdResponse> =>
    fetchNext(requestTypes.GET, `/news/${id}/detail`, undefined, newsUrl);

  static getNewsFiles = (id: number): Promise<GetNewsFileByIdResponse> =>
    fetchNext(requestTypes.GET, `/news/${id}/files`, undefined, newsUrl);
}
